import React, { Component } from "react";
import { Link } from "react-router-dom";
import moment from "moment";

export default class ListItem extends Component {
  render() {
    const {
      order,
      handleOpenOrderSection,
      handleRateOrder,
      handleReOrder,
      pathname,
      search
    } = this.props;
    const today = moment(new Date());
    const orderDate = moment.utc(order.orderDate).local();
    const diff = today.diff(orderDate, "hours");
    let formattedDate,
      formattedText = "";
    if (diff <= 1) {
      formattedDate = orderDate.format("mm");
      formattedText = "mins";
    } else if (1 < diff && diff <= 23) {
      formattedDate = diff;
      formattedText = "hours";
    } else if (diff > 23) {
      formattedDate = orderDate.format("DD MMMM YYYY");
      formattedText = "";
    }
    const className = (order.userCanRate && "active") || "";
    const disabled = !order.userCanRate;

    return (
      <div className="order-items">
        <Link
          to={{
            pathname,
            search,
            hash: `${order.uid}`
          }}
          onClick={() => handleOpenOrderSection(order.uid)}
        >
          <p className="date">
            {formattedDate} {formattedText}
          </p>
          <div className="desc">
            <span>Order #{order.uid}</span>
            <p>{order.restaurant.name}</p>
            <div className="visible-xs">
              <p>£{parseFloat(order.total).toFixed(2)}</p>
              <p>+{order.earnedPoints} eCoins</p>
            </div>
          </div>
          <div className="hide-xs flex-grow-1 total">
            <p>£{parseFloat(order.total).toFixed(2)}</p>
          </div>
          <div className="hide-xs flex-grow-1 points">
            <p className="bold">+{order.earnedPoints} eCoins</p>
          </div>
        </Link>
        <div className="buttons">
          <a
            onClick={() => handleRateOrder(order.uid, disabled)}
            href="javascript: void(0)"
            className={className}
          >
            Rate
          </a>
          <a
            onClick={() => handleReOrder(order.uid)}
            href="javascript: void(0)"
          >
            Reorder
          </a>
        </div>
      </div>
    );
  }
}
